<template>
	<div class="k-page-content" v-loading="loading">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane :label="infoData.title_info.title" name="first" v-if="infoData.title_info.title">
				<div class="k-page-common">
					<div class="k-common-header" style="padding: 12px;">
						<div class="proDeTitle">
							<div>
								<span class="t1">{{ infoData.title_info.title }}：</span>
								<span class="t2">{{ infoData.title_info.code }}</span>
								<span class="t3">{{ infoData.title_info.status }}</span>
							</div>
							<div class="back" @click="goBack()">
								<i class="el-icon-back"></i>返回上一页
							</div>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="whiteBox" style="padding-bottom: 0;">
								<div class="projectDetailTop">
									<div class="tyTitle">
										<p>基本信息</p>
									</div>
									<div class="detailBox">
										<ul>
											<li v-for="(item, index) in infoData.info" :key="index" v-if="item.type == 'text'">
												<span class="title">{{ item.label }}</span>
												<div class="con"
													:style="{ color: item.style === 'red' ? 'red' : '', 'font-weight': item.style === 'red' ? 'bold' : '' }">
													{{ item.value }}</div>
											</li>
											<li v-for="(item, index) in infoData.info" :key="index" v-if="item.type == 'img'">
												<span class="title">{{ item.label }}</span>
												<div class="con">
													<template v-if="item.value && item.value.length > 0">
														<span v-for="(itema, indexa) in item.value" :key="indexa">
															<el-link type="primary" :href="itema" target="_blank">附件{{ indexa + 1 }}</el-link>{{
																indexa ==
																	item.value.length - 1 ? '' : '、' }}
														</span>
													</template>
													<span v-else>--</span>
												</div>
											</li>
										</ul>
									</div>
									<div style="padding-bottom: 20px;" v-for="(item, index) in infoData.info" :key="index"
										v-if="item.type == 'table'">
										<div class="tyTitle">
											<p>{{ item.label }}</p>
										</div>
										<el-table :data="item.value.data" style="width: 100%" row-key="id" border stripe ref="tablecontract"
											v-loading="loading" highlight-current-row>
											<template v-for="(itemc, indexc) in item.value.field">
												<el-table-column :prop="itemc.prop" :label="itemc.title">
												</el-table-column>
											</template>
										</el-table>
									</div>
								</div>
							</div>
						</div>
						<actionBar v-if="queryParams.type == 'approve' && infoData.title_info.title" :actioninfo="infoData"
							:loading.sync="loading"></actionBar>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
import layoutStep from '../approve/Step.vue'
import actionBar from '../approve/Actionbar.vue'
export default {
	props: ['info'],
	components: {
		layoutStep,
		actionBar
	},
	data () {
		return {
			activeName: 'first',
			size: 'mini',
			loading: false,
			infoData: {
				info: [],
				title_info: {},
				step_info: {}
			},
			queryParams: ''//跳转页面携带参数
		}
	},
	computed: {
	},
	mounted: function () {
		this.loading = true
		this.queryParams = this.$route.query;
		this.getDetail()
	},
	methods: {
		//获取详情
		getDetail () {
			let params = {}
			params.id = this.queryParams.id
			if (this.queryParams.set_id) {
				params.set_id = this.queryParams.set_id
			}
			if (this.queryParams.log_id) {
				params.log_id = this.queryParams.log_id
			}
			this.$api.get('/admin/customers/customer/getexamineinfoview', params).then(res => {
				if (res.code === 0) {
					this.infoData = res.data
					this.loading = false
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		goBack () {
			window.history.back()
		}
	}
}
</script>
<style lang="scss" scoped>
.resourceCon {
	.addBox {
		margin-top: 60px;
	}

	.fyRadio {
		width: 94px;
		height: 40px;
		background: #fbfbfe;
		border: 1px solid #d7dae2;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 20px;
			height: 20px;
			margin-right: 6px;
		}

		.fyRadioTitle {
			font-size: 14px;
			font-weight: 400;
			color: #78859b;
		}
	}

	.el-radio {
		display: inline-flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 20px;
	}
}

.projectDetailInfo {
	position: relative;
	padding-left: 60px;
	height: 100%;
	margin-top: 20px;
	padding-bottom: 10px;

	.base-info-wrap {
		margin-bottom: 10px;

		.row {
			display: flex;
			font-size: 14px;
			align-items: center;
			flex-wrap: wrap;

			.column {
				width: 20%;
				padding-bottom: 14px;

				.column-label {
					margin-right: 14px;
					color: #a1a1a1;
				}

				.column-value {
					word-break: break-all;
					color: #333;

					&.red {
						color: #fb5555 !important;
						font-weight: 500;
					}
				}
			}
		}
	}

	.bg {
		position: absolute;
		top: 0;
		left: -24px;
		width: 36px;
		height: 100%;
		background: url(../../assets/images/titbg.png) no-repeat;
		background-size: 100% 100%;
		writing-mode: vertical-lr;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-left: 6px;
		font-size: 14px;
		text-indent: 10px;
		letter-spacing: 12px;
		color: #775905ec;
		border-radius: 8px;
		overflow: hidden;
	}

	.des {
		position: relative;
		color: #333;
		background: #f9fafd;
		border-radius: 8px;
		padding: 6px 10px;
		line-height: 30px;
		margin-top: -14px;
		font-size: 14px;

		div {
			white-space: pre-wrap;
		}

		span {
			font-weight: bolder;
			white-space: nowrap;
		}

		.desdemand {
			padding: 10px;
		}
	}
}

.projectDetailCenter {
	display: flex;
	justify-content: space-between;

	.left {
		width: calc(100% - 370px);
		height: 240px;
	}

	.right {
		width: 350px;
		height: 240px;
	}
}
</style>